import { ILeadApi, ILeadsApi } from './Leads-api.properties';
import {
  IMessageBaseProps,
  MessageBaseModel,
  MessageSource,
} from './Message.model';

export interface LeadsModelProps {
  leads: LeadModel[];
}

export class LeadsModel implements LeadsModelProps {
  leads: LeadModel[];

  constructor(data: LeadsModelProps) {
    this.leads = data.leads;
  }

  static fromApiResponse(data: ILeadsApi) {
    const leads = data.map((lead) => LeadModel.fromApiResponse(lead));

    return new LeadsModel({
      leads,
    });
  }

  static empty() {
    return new LeadsModel({
      leads: [],
    });
  }
}

export interface ILeadModelProps extends IMessageBaseProps {
  email: string;
  phone: string;
  readStatus: 'READ' | 'NEW';
  shortMessage: string;
  favorite?: boolean;
}

export class LeadModel extends MessageBaseModel implements ILeadModelProps {
  email: string;
  phone: string;
  date: string;
  readStatus: 'READ' | 'NEW';
  shortMessage: string;
  favorite?: boolean;

  constructor(data: ILeadModelProps) {
    super({
      id: data.id,
      senderName: data.senderName,
      message: data.message,
      createTime: data.createTime,
      source: data.source,
    });

    this.email = data.email;
    this.phone = data.phone;
    this.readStatus = data.readStatus;

    const shortMsg =
      (data.shortMessage || '').substring(0, 50) ||
      (data.message || '').substring(0, 50);

    this.shortMessage =
      shortMsg.length >= 50 ? shortMsg.concat('...') : shortMsg;

    this.source = data.source;
  }

  static fromApiResponse(data: ILeadApi): LeadModel {
    return new LeadModel({
      id: +data.id,
      senderName: data.name,
      message: data.message,
      email: data.email,
      phone: data.phone,
      createTime: data.timestamp,
      readStatus: data.read_status,
      shortMessage: data.message,
      source: MessageSource.EMAIL,
    });
  }

  static empty(): LeadModel {
    return new LeadModel({
      id: null,
      senderName: '',
      createTime: null,
      message: '',
      email: null,
      phone: null,
      readStatus: null,
      shortMessage: null,
      source: null,
      favorite: false,
    });
  }
}
